module.exports = __webpack_public_path__ + "img/forecasting-house-model.b0f15f45.png";